import {Component, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {environment} from '../environments/environment';
import {Ambiente} from './components/shared/enum/ambiente';
import {MethodsUtils} from './components/shared/util/methods.utils';
import {NgClass} from '@angular/common';
import {AuthServiceService} from './components/shared/service/auth-service.service';
import {MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';
import {TituloComponent} from './components/titulo/titulo.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgClass, MatSidenavContent, MatSidenavContainer, TituloComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  isProd: boolean = environment.ambiente == Ambiente.PROD;
  isMobile: boolean = MethodsUtils.resolucaoPolegadas() < 13;
  isClicked: boolean = false;
  ambiente: string = environment.ambiente;
  protected readonly platformBrowser = navigator.userAgent;
  deslogado: boolean = false;
  titulo: string = '';

  constructor(
    private authService: AuthServiceService
  ) { }

  ngOnInit() {
    setInterval(() => {
      if (!this.authService.logado()) {
        this.authService.logout();
      }
    }, 100);
  }

  mostrarDetalhesPlataforma() {
    this.isClicked = !this.isClicked;
  }

  get avisoTexto(): string {
    return this.isClicked
      ? `Aviso: Você está em ambiente de ${this.ambiente}. Plataforma: ${this.platformBrowser}`
      : `Aviso: Você está em ambiente ${this.ambiente === 'local' ? this.ambiente : 'de ' + this.ambiente}.`;
  }

  get estaLogado(): boolean {
    if (this.authService.logado()) {
      if (this.deslogado) {
        this.deslogado = false;
      }
      return true;
    } else {
      if (!this.deslogado) {
        this.authService.logout();
        this.deslogado = true;
      }
      return false;
    }
  }

  calcularHeightPagina() {
    if (!this.estaLogado) {
      return '100vh';
    }

    if (!this.isProd && !this.isMobile) {
      return 'calc(100vh - 16px)';
    }

    if (this.isProd && !this.isMobile) {
      return '100vh';
    }
    return '100vh';
  }
}
